enum ViewerMethod {
  GET_HIGHLIGHTS = "Book.getHighlights",
  GET_CITATIONS = "Book.getCitations",
  GET_TOC = "Book.getTOC",
  GET_PAGE_BREAKS = "Book.getPageBreaks",
  GET_UNIVERSAL_URL = "Book.getUniversalURL",
  GET_FIGURES = "Book.getFigures",

  HAS_NEXT_CONTENT_DOC = "Book.hasNextContentDoc",
  HAS_PREVIOUS_CONTENT_DOC = "Book.hasPreviousContentDoc",
  GO_TO_NEXT_PAGE = "Book.goToNextPage",
  GO_TO_NEXT_PAGE_BREAK = "Book.goToNextPageBreak",
  GO_TO_PREV_PAGE = "Book.goToPreviousPage",
  GO_TO_PREV_PAGE_BREAK = "Book.goToPreviousPageBreak",
  GO_TO_PAGE = "Book.goToPage",
  GO_TO_URL = "Book.goToURL",
  GO_TO_CFI = "Book.goToCfi",
  GO_TO_BOOKMARK = "Book.goToBookmark",
  GET_REBUILD_PROGRESS = "Book.getRebuildProgress",
  REGISTER_POI = "Book.registerPOI",

  SET_BOOKMARK = "Bookmarks.setBookmark",
  DELETE_BOOKMARK = "Bookmarks.deleteBookmark",
  GET_BOOKMARKS = "Bookmarks.getBookmarks",
  GO_TO_FIGURE = "Book.goToFigure",

  IMAGE_TOOLS_FOCUS = "ImageTools.focus",
  IMAGE_TOOLS_RECONFIGURE = "ImageTools.reconfigure",

  GO_TO_HIGHLIGHT = "Highlights.goToHighlight",
  DELETE_HIGHLIGHT = "Highlights.deleteHighlight",
  UPDATE_HIGHLIGHT = "Highlights.updateHighlight",
  HIGHLIGHT_CURRENT_SELECTION = "Highlights.highlightCurrentSelection",
  REDRAW_HIGHLIGHTS = "Highlights.redrawHighlights",

  GET_BOOK_INFO = "Book.getInfo",

  SEARCH_BOOK_CONTENT = "Search.searchContentInOneBook",
  GO_TO_SEARCH_RESULT = "Search.goToSearchResultInOneBook",
  HIGHLIGHT_SEARCH_RESULTS = "SearchHighlighter.highlightSearchResultsInOneBook",
  UNHIGHLIGHT_SEARCH_RESULTS = "SearchHighlighter.unhighlightSearchResultsInOneBook",

  ADD_ENHANCED_FORMATTING_CSS = "ContentControls.addEnhancedFormattingCSS",
  REMOVE_ENHANCED_FORMATTING_CSS = "ContentControls.removeEnhancedFormattingCSS",
  SET_READER_VIEW = "ContentControls.setReaderView",
  SET_DISPLAY_MODE = "ContentControls.setDisplayMode",
  SET_LINE_HEIGHT = "ContentControls.setLineHeight",
  SET_FONT_FAMILY = "ContentControls.setFontFamily",
  SET_PAGE_MARGIN = "ContentControls.setMargin",
  SET_TEXT_SIZE = "ContentControls.setTextSize",

  ZOOM_IN = "ContentControls.increaseZoomScale",
  ZOOM_OUT = "ContentControls.decreaseZoomScale",
  SET_ZOOM = "ContentControls.setZoomScale",
  GET_ZOOM = "ContentControls.getZoomScale",
  FIT_WIDTH = "ContentControls.fitToWidth",
  FIT_HEIGHT = "ContentControls.fitToHeight",

  PRINT = "Printer.print",
  PRINTTRIGGER = "Printer.printTrigger",
  PRINTCLEANUP = "Printer.printCleanup",
  GET_PRINT_HISTORY = "Printer.getPrintHistory",
  GET_BOOK_PRINT_LIMITS = "Printer.getBookLimits",
  GET_LIFETIME_PRINT_PAGES = "Printer.getLifetimePages",

  TTS_SEND_STATUS = "TTS.sendStatus",
  TTS_GET_SETTINGS = "TTS.getCurrentSettings",
  TTS_PLAY_FROM_TOP = "TTS.playFromTop",
  TTS_PLAY_FROM_LOCATION = "TTS.playFromLocation",
  TTS_PLAY_FROM_CURRENT_SELECTION = "TTS.playFromCurrentSelection",
  TTS_ENABLE_ALT_TEXT = "TTS.enableAltText",
  TTS_DISABLE_ALT_TEXT = "TTS.disableAltText",
  TTS_STOP = "TTS.stop",
  TTS_PAUSE = "TTS.pause",
  TTS_RESUME = "TTS.resume",
  TTS_SET_VOICE_INDEX = "TTS.setVoiceIndex",
  TTS_SET_RATE = "TTS.setRate",
  TTS_SKIP_FORWARD = "TTS.skipForward",
  TTS_SKIP_BACK = "TTS.skipBack",
  TTS_SET_NO_CONTENT_MSG = "TTS.setNoContentMessage",
  TTS_GET_VOICES = "TTS.getVoices",

  TRACK_LOCATION = "Locations.trackLocation",
  RESET_TRACKED_LOCATIONS = "Locations.resetTrackedLocations",
  SEND_TRACKED_LOCATIONS = "Locations.sendTrackedLocations",

  SCROLL_TO_Y = "Viewport.scrollTo",

  SET_PADDING = "Padding.setPadding",
  ADD_TO_PADDING = "Padding.addToPadding",
  SET_LAYOUT_MODE = "Book.setMode",

  LAUNCH_APP = "ReadOffline.launchApp",
  DOWNLOAD_APP = "ReadOffline.downloadApp",

  CLEAR_SELECTION = "TextSelection.clearSelections",
  GET_DYNAMIC_URL = "ReadOffline.getDynamicUrl",
  GET_APP_SSO_URL = "ReadOffline.getAppSSOUrl",

  UPDATE_USER_BOOK_PREFS = "Book.updateUserPreferences",
}

export default ViewerMethod;
